/* eslint-disable */
import Vue from 'vue';
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';

import { required, email, min_value, max_value, min, max } from 'vee-validate/dist/rules';
import { i18nValidation } from '../localize';

import moment from 'moment';

extend('max', max);
extend('min', min);

extend('required', {
    ...required,
    message: (_field) => i18nValidation.t('form.errors.required')
});
extend('max_value', {
    ...max_value,
    message: (_field) => i18nValidation.t('form.errors.max_value')
});
extend('email', {
    ...email,
    message: (_field) => i18nValidation.t('form.errors.email')
});
extend('min_value', {
    ...min_value,
    message: (_field) => i18nValidation.t('form.errors.min_value')
});
extend('time_period', {
    message: (_field) => `start date cannot be after end date `,
    validate: (value) => {
        // date_start must be before date_end or on same day, otherwise return false
        return moment(value.date_start).isSame(value.date_end) || moment(value.date_start).isBefore(value.date_end);
    }
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);



// WEBPACK FOOTER //
// ./src/vee-validate/vee-validate.js